import { html, KompisElement, property, unsafeHTML } from '@inter-ikea-kompis/web-component';
import type { ITheme } from '@inter-ikea-kompis/types';
import { SafariWriteDirectionUtility } from '@inter-ikea-kompis/utilities';
import type { RenderResult } from '@inter-ikea-kompis/web-component';

import IconSizeCalculator from '../../utilities/IconSizeCalculator.js';

// The base size UX uses when designing icons
const BASE_SIZE = 24;

/**
 * @deprecated This component has been deprecated, see Kompis page for more info.
 *
 * Icon component.
 */

export default class Icon extends KompisElement {
	// SVG code
	@property({ type: String, required: true })
	public icon!: string;

	// Theme
	@property({ type: Object, required: true })
	public theme!: ITheme;

	// Flip the icon horizontally in RTL context
	@property({ type: Boolean })
	public flipIconRtl = false;

	/**
	 * Renders the component.
	 *
	 * @returns Template.
	 */
	public override render(): RenderResult {
		if (!this.icon) {
			return null;
		}

		const { width, height } = IconSizeCalculator.getMeasuredSize(this.icon, BASE_SIZE);
		const direction = SafariWriteDirectionUtility.getWriteDirection(this);
		return html`
			<style>
				:host {
					display: inline-flex;
					justify-content: center;
					align-items: center;
				}
				svg {
					overflow: visible;
					width: ${IconSizeCalculator.round(width / 16)}rem;
					height: ${IconSizeCalculator.round(height / 16)}rem;
				}

				${this.flipIconRtl ? this.getFlipIconRtlStyle(direction) : null}
			</style>
			${unsafeHTML(this.icon.replace('<svg', '<svg aria-hidden="true"'))}
		`;
	}

	/**
	 * Style for flip icon.
	 *
	 * @param direction Direction.
	 * @returns Style for kiosk.
	 */
	private getFlipIconRtlStyle(direction: string | null): string {
		if (direction === 'rtl') {
			return `
				:host {
					transform: scaleX(-1);
				}
				:host-context {
					transform: scaleX(-1);
				}
			`;
		}
		return `
			:host(:dir(rtl)) {
				transform: scaleX(-1);
			}
			:host-context([dir='rtl']) {
				transform: scaleX(-1);
			}
		`;
	}
}
declare global {
	interface HTMLElementTagNameMap {
		'kompis-icon': Icon;
	}
}
